//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import DescriptivetrainingformModule from 'app_components/modules/admin/landings/descriptivetrainingform';
// import SchedulingFormModule from 'app_components/modules/admin/landings/schedulingForm/index';
// import ReferenceFormModule from 'app_components/modules/admin/landings/referencesForm/index';
//@end

// @import hooks
// @end

// @INFO Import types
import { ILanding } from 'app_types/admin/landings/landingTypes';
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import '../alliancesLandingModule.scss'
import AllianceFormModuleLayout from '../../alliancesFormModule/allianceFormModule';

// @ADD Component types
interface IAlliancesLandingModuleLayoutProps {
  permission: any
  onHandleSaved: (data: any) => void | null
  landingInfo: ILanding | null
  loadingForm: 'loading' | null
}

const AlliancesLandingModuleLayout: React.FC<IAlliancesLandingModuleLayoutProps> = (props) => {
  const {permission} = props
  const { t } = useTranslation()

  return(
    <div className='alliances_landing_module-layout'>

      {permission.checkSimple(`permission:landings_alliances_article`) ? (
        <DescriptivetrainingformModule
          title='Articulo'
          data={props.landingInfo?.landing?.descriptive_training}
          source='alliances'
          onHandleDescriptiveTrainingSaved={props.onHandleSaved}
        />
      ): null}

      {permission.checkSimple(`permission:landings_alliances_items`) ? (
        <AllianceFormModuleLayout
          title='Alianzas estrategicas'
          addItem={permission.checkSimple(`permission:landings_alliances_items_create`)}
          editItem={permission.checkSimple(`permission:landings_alliances_items_update`)}
          deleteItem={permission.checkSimple(`permission:landings_alliances_items_delete`)}
          source='alliances'
          onHandleFormSubmited={props.onHandleSaved}
          items={props.landingInfo?.landing?.alliances}
        />
      ): null}
    </div>
  )
}

export default AlliancesLandingModuleLayout
